// extracted by mini-css-extract-plugin
export var box = "_z-2";
export var checkboxControl = "_z-0";
export var checkboxRow = "_z-a";
export var checked = "_z-3";
export var descriptionSpacer = "_z-c";
export var disabled = "_z-4";
export var icon = "_z-8";
export var input = "_z-1";
export var labelSpacer = "_z-b";
export var large = "_z-7";
export var medium = "_z-6";
export var small = "_z-5";
export var text = "_z-9";